import { render } from "./OrderTheLetters.vue?vue&type=template&id=fec610ec&scoped=true"
import script from "./OrderTheLetters.vue?vue&type=script&lang=js"
export * from "./OrderTheLetters.vue?vue&type=script&lang=js"

import "./OrderTheLetters.vue?vue&type=style&index=0&id=fec610ec&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/Taitaen Swegon Prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec610ec"]])

export default __exports__